import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const MyHomeFormContainer: React.FC = () => {
  const { logger, custom } = useApplicationContext();
  const manifest = custom.myHomeFormManifest;

  if (!manifest) {
    if (process.env.IS_BROWSER_BUILD === 'true') {
      logger.error('Отсутствует манифест микрофронта формы добавления моего дома', {
        domain: 'microfrontends.frontend-valuation-form.manifest',
      });
    }

    return null;
  }

  return <Microfrontend {...manifest} />;
};
